const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/gamification/rewards.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// Admin Rewards Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/gamification/rewards")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Rewards",
      description: "Page title"
    })
  }
});